import { useSupabaseClient } from '@supabase/auth-helpers-react'
import { Database } from 'integrations/supabase/generated.types'
import { APYCalculationMethod, ManualAPYOverride } from 'types/Portfolio/APYCalculation'
import { useMutation } from '@tanstack/react-query'

export function useSaveOfferingApyCalculationMethod(offeringId: string) {
  const supabase = useSupabaseClient<Database>()
  return useMutation({
    mutationFn: async ({
      method,
      manualAPYOverride,
    }: {
      method: APYCalculationMethod
      manualAPYOverride: ManualAPYOverride | null
    }) => {
      await supabase.from('LiveOffering').update({ apyCalculationMethod: method }).eq('id', offeringId)

      if (method === 'manual' && manualAPYOverride) {
        await supabase
          .from('LiveOfferingManualAPY')
          .upsert({
            offeringId,
            value: manualAPYOverride.value,
            name: manualAPYOverride.name,
            description: manualAPYOverride.description,
          })
          .eq('id', offeringId)
      }
    },
  })
}
